import React from 'react';
import './styles.scss';

const Footer = props => {
  return (
    <footer className="footer">
      <div className="wrap">
        © eStore 2021
      </div>
    </footer>
  );
}

export default Footer;